import React, { useEffect, useState } from "react";
import {
  ButtonGroup,
  CardRowMain,
  NotFoundMain,
  ProfileWrapper,
  Tab,
  UserProfileBtn,
} from "./userProfileElement";
import * as P from "components/collection/collectionElement";
import * as C from "components/common";
import { useAppSelector, useAppDispatch } from "store/store";
import { Loader } from "components/common";
import { MainModel } from "components";
import {
  connectModelSlice,
  mainModel,
  reportModelSlice,
} from "store/redux/slices/helperSlices/modelSlice";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import {
  GetUserHook,
  UserNFTListHook,
  GetNftsByNftIdsHook,
  UserFavouritesHooks,
  ChangeFavouriteHook,
  RemoveFavouriteHook,
} from "hooks";
import { ContractUtility } from "utility";
import { CollectionSidebar, CollectionMobileSidebar } from "components";
import { useNavigate } from "react-router-dom";
import env from "environment";
import ProfileNftCards from "./profileNftCard";
import {
  FaEthereum,
  IoCreateSharp,
  AiOutlineFileAdd,
  AiTwotoneHeart,
  AiFillFlag,
  BsFacebook,
  BsTwitter,
  AiOutlineCopy,
  BsShare,
  IoSettingsOutline,
} from "react-icons/all";
import { CommonUtility } from "utility";
import CollectionCard from "components/collectionAll/collectionCard";

const suffix = (
  <SearchOutlined
    style={{
      fontSize: 14,
      color: "#1890ff",
    }}
  />
);

// Tabs
const types = ["Collected", "Created", "Favourite"];

interface Props {
  mainBg?: boolean;
  profileBg?: boolean;
  bgImg?: string;
  profileUpload?: boolean;
  profileScreenBtn?: boolean;
  profileScreenDesc?: boolean;
  detailsTab?: string;
  activeTab?: Boolean;
  profileScreenReport?: boolean;
  isShareBtn?: boolean;
  isSettingBtn?: boolean;
}

const UserProfileCom: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const filterDataInit = {
    created: null,
    collected: null,
    fav: null,
  };
  const environment = require("environment");
  const upload = {
    name: "file",
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
  };

  const [active, setActive] = useState(types[0]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState(filterDataInit);

  const { web3, account, chainId } = useAppSelector(
    (state) => state.web3Connect
  );

  const { data, loading } = UserNFTListHook(
    ContractUtility.getNetwork(chainId),
    account ? account : ""
  );

  const { user, loading: userLoading, error } = GetUserHook(account);
  const {
    removeFav,
    removeLoading,
    data: favRemoveData,
  } = RemoveFavouriteHook();

  const {
    getNfts,
    data: createdNfts,
    loading: createdNftsLoading,
  } = GetNftsByNftIdsHook();
  const {
    getFavourites,
    loading: favouritesLoading,
    favourites,
    refetch,
  } = UserFavouritesHooks();

  const [tabsFlag, setTabsFlag] = useState({
    collected: false,
    created: true,
    favourite: false,
  });

  const connectModelFn = () => {
    dispatch(connectModelSlice(true));
  };

  const reportModelOpen = () => {
    dispatch(reportModelSlice(true));
  };
  const goToProfileSetting = () => {
    navigate("/profile-setting/");
  };

  useEffect(() => {
    if (active == "Collected") {
      navigate("/profile/collected");
    }

    if (active == "Created") {
      navigate("/profile/created");
    }

    if (active == "Favourite") {
      navigate("/profile/favourite");
    }
  }, [active]);

  useEffect(() => {
    data &&
      getNfts(
        data.map((d) =>
          CommonUtility.makeNftId(d?.asset_contract?.address, d?.token_id)
        )
      );
  }, [data]);

  useEffect(() => {
    favRemoveData && refetch();
  }, [favRemoveData]);

  useEffect(() => {
    web3 && getFavourites();
  }, [web3]);

  useEffect(() => {
    const searchFilter = () => {
      const lowerTerm = searchTerm.toLocaleLowerCase();
      const created = createdNfts.filter((x) =>
        x.name?.toLocaleLowerCase().includes(lowerTerm)
      );

      const fav =
        favourites &&
        favourites.filter((x) =>
          x.metadata?.name
            ? x.metadata?.name?.toLocaleLowerCase().includes(lowerTerm)
            : x.metadata?.asset_contract?.name
                ?.toLocaleLowerCase()
                .includes(lowerTerm)
        );

      if (created.length > 0) {
        const collected = data.filter(
          (x) =>
            created.some((c) => c.nft_id === x.id) ||
            x.name?.toLocaleLowerCase().includes(lowerTerm) ||
            x.asset_contract?.name?.toLocaleLowerCase().includes(lowerTerm)
        );
        setFilteredData({ ...filteredData, created, collected, fav });
      } else {
        const collected = data.filter(
          (x) =>
            !createdNfts.some((c) => c.nft_id === x.id) &&
            (x.name?.toLocaleLowerCase().includes(lowerTerm) ||
              x.asset_contract?.name?.toLocaleLowerCase().includes(lowerTerm))
        );
        setFilteredData({ ...filteredData, created: [], collected, fav });
      }
    };
    searchTerm ? searchFilter() : setFilteredData(filterDataInit);
  }, [searchTerm]);

  const shareMenu = (
    <C.DropdownMenu>
      <C.DropdownItem>
        <BsFacebook
          style={{
            fontSize: "1.2rem",
            marginTop: "-0.2rem",
            marginLeft: "0.5rem",
          }}
        />

        <C.DropdownItemA
          href="https://www.facebook.com/sharer/sharer.php?u=example.org"
          target="_blank"
        >
          share on facebook
        </C.DropdownItemA>
      </C.DropdownItem>
      <hr style={{ marginTop: "0.5rem" }} />
      <C.DropdownItem style={{ marginTop: "-0.8rem" }}>
        <BsTwitter
          style={{
            fontSize: "1.2rem",
            marginTop: "rem",
            marginLeft: "0.5rem",
          }}
        />
        <C.DropdownItemA
          // rel="noopener noreferrer"
          href="https://twitter.com/intent/tweet"
          target="_blank"
        >
          share on twitter
        </C.DropdownItemA>
      </C.DropdownItem>
      <hr style={{ marginTop: "0.5rem" }} />

      <C.DropdownItem
        style={{ marginTop: "-0.8rem" }}
        onClick={() =>
          CommonUtility.copyToClipboard(
            `${window.location.origin}/profile-setting/profile?refer=${user.walletAddress}`,
            "Successful"
          )
        }
      >
        <AiOutlineCopy
          style={{
            fontSize: "1.2rem",
            marginTop: "0rem",
            marginLeft: "0.5rem",
          }}
        />

        <C.DropdownItemA> copy reference link</C.DropdownItemA>
      </C.DropdownItem>
    </C.DropdownMenu>
  );

  return (
    <ProfileWrapper className="userProfile" style={{ overflowX: "hidden" }}>
      <MainModel />{" "}
      {!web3 && (
        <div className="d-flex justify-content-center mt-1">
          <C.MainButton connectModel onClick={connectModelFn}>
            Connect Wallet
          </C.MainButton>
        </div>
      )}
      {web3 && (
        <>
          <C.MainRow>
            <C.MainProfileBg mainBg bgImg={user.coverImage}>
              <C.MainUpload {...upload}>
                <C.MainUploadBtn icon={<EditOutlined />}> </C.MainUploadBtn>
              </C.MainUpload>
            </C.MainProfileBg>

            <C.MainCol></C.MainCol>
          </C.MainRow>
          <C.MainRow style={{ justifyContent: "end" }}>
            <C.MainCol lg={8}>
              <C.MainProfileBg profileBg bgImg={user.profImage}>
                <C.MainUpload {...upload}>
                  <C.MainUploadBtn
                    icon={<EditOutlined />}
                    profileUpload
                  ></C.MainUploadBtn>
                </C.MainUpload>
              </C.MainProfileBg>

              <P.MainProfileTitle>{user.name}</P.MainProfileTitle>
              <P.MainProfileSocailBtn
                profileScreenBtn
                onClick={() =>
                  CommonUtility.copyToClipboard(account, "Successful")
                }
              >
                <FaEthereum color="#808080" fontSize={15} />
                {CommonUtility.addressConvertor(account || "")}
              </P.MainProfileSocailBtn>
              <P.MainProfileDesc profileScreenDesc>
                Joined {CommonUtility.mm_yy(user.createdAt)}
              </P.MainProfileDesc>
            </C.MainCol>
            <C.MainCol lg={2}>
              <div
                style={{
                  justifyContent: "end",
                  display: "flex",
                  gap: "1.8rem",
                  marginRight: "1rem",
                }}
              >
                <div>
                  <C.Dropdowns overlay={shareMenu} trigger={["click"]}>
                    <UserProfileBtn isShareBtn>
                      <BsShare color="black" />
                    </UserProfileBtn>
                  </C.Dropdowns>
                </div>
                <div>
                  <UserProfileBtn isSettingBtn>
                    <IoSettingsOutline
                      color="black"
                      onClick={goToProfileSetting}
                    />
                  </UserProfileBtn>
                </div>
              </div>
            </C.MainCol>
          </C.MainRow>
          <C.MainRow></C.MainRow>
          <C.MainContainer>
            <C.MainRow>
              <C.MainCol lg={12}>
                <ButtonGroup>
                  {types.map((type) => (
                    <Tab
                      key={type}
                      activeTab={active === type}
                      onClick={() => setActive(type)}
                    >
                      {type == "Collected" && (
                        <AiOutlineFileAdd style={{ marginRight: "0.7rem" }} />
                      )}
                      {type == "Favourie" && (
                        <AiTwotoneHeart style={{ marginRight: "0.7rem" }} />
                      )}
                      {type == "Created" && (
                        <IoCreateSharp style={{ marginRight: "0.7rem" }} />
                      )}

                      {type}
                    </Tab>
                  ))}
                </ButtonGroup>
                <p />
              </C.MainCol>
            </C.MainRow>

            <C.MainRow>
              <C.MainRow className="d-flex mt-5  justify-content-center">
                <C.MainCol lg={5}>
                  <P.MainSectionSearch
                    prefix={suffix}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Search NFTs"
                    allowClear
                  />
                </C.MainCol>
              </C.MainRow>
              {loading ||
                userLoading ||
                createdNftsLoading ||
                (favouritesLoading && <Loader content="Loading" />)}

              <CardRowMain className="mb-5">
                {active === "Collected" && data && data.length > 0 ? (
                  (filteredData.collected || data)?.map((item, i) => {
                    const created = createdNfts.find(
                      (x) => x.nft_id === item.id
                    );
                    const fav = created?.favourites?.find(
                      (x) => x.user_address === account?.toLocaleLowerCase()
                    );
                    const data = {
                      user: true,
                      metadata_id: item?.id,
                      metadata: {
                        id: item?.id,
                        price: created?.sellNft?.signed_order.erc20TokenAmount,
                        network: created?.sellNft?.network,
                        erc20Token: created?.sellNft?.signed_order.erc20Token,
                        sold: false,
                        token_id: item?.token_id,
                        name:
                          created?.name ||
                          item?.name ||
                          item?.asset_contract.name,
                      },
                      image: created?.image || item?.image_preview_url,
                      nft_id: item?.id,
                      buttonTxt: "Details",
                    };
                    return (
                      <div key={i} className="flex-item ">
                        <CollectionCard data={data} />
                      </div>
                    );
                  })
                ) : active === "Created" && createdNfts?.length > 0 ? (
                  (filteredData.created || createdNfts)?.map((item, i) => {
                    const data = {
                      user: true,
                      metadata: {
                        id: item?.nft_id,
                        price: item?.sellNft?.signed_order.erc20TokenAmount,
                        network: item?.sellNft?.network,
                        erc20Token: item?.sellNft?.signed_order.erc20Token,
                        sold: false,
                        token_id: CommonUtility.deStructureNftId(item?.nft_id)
                          .tokenId,
                        name: item?.name,
                      },
                      buttonTxt: "Details",
                      image: item?.image,
                    };
                    return (
                      <div key={i} className="flex-item ">
                        <CollectionCard data={data} />
                      </div>
                    );
                  })
                ) : active === "Favourite" && favourites?.length > 0 ? (
                  (filteredData.fav || favourites)?.map((item, i) => {
                    const data = {
                      ...item,
                      favId: item.id,
                      buttonTxt: item?.metadata?.unlist
                        ? "unlisted"
                        : item?.metadata?.sold
                        ? "Sold Out"
                        : "Buy Now",
                      changeFav: removeFav,
                      metadata_id: item?.metadata.id,
                      image:
                        item?.metadata?.image ||
                        item?.metadata?.image_preview_url,
                      nft_id: item?.metadata ? item.metadata.id : item.nft_id,
                    };
                    return (
                      <div key={i} className="flex-item ">
                        <CollectionCard data={data} />
                      </div>
                    );
                  })
                ) : (
                  <C.MainCol lg={12}>
                    <NotFoundMain className="offerMain">
                      <div className="noOfferDiv">
                        <p className="noOffer">No Nft Found</p>
                      </div>
                    </NotFoundMain>
                  </C.MainCol>
                )}
              </CardRowMain>
            </C.MainRow>
          </C.MainContainer>
        </>
      )}
    </ProfileWrapper>
  );
};

export default UserProfileCom;
